<template>
  <v-card class="d-flex flex-column align-center pa-6" flat tile height="550">
    <div class="w-full d-flex justify-end">
      <v-btn icon @click="handleClose">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </div>
    <div class="container-title justify-center" style="flex: 1">
      <v-progress-circular color="brand" indeterminate />
      <h1 class="body-bold-medium neutral-20-dark--text mt-4">
        {{ workflowTexts.title }}
      </h1>
      <span
        v-if="type !== 'AiWorkFlow'"
        class="body-regular-smaller neutral-40-light--text text-center"
        >{{ $t('message.ai.toastWait') }}</span
      >
      <span
        class="body-regular-small neutral-20-dark--text text-center"
        v-html="workflowTexts.subtitle"
      >
      </span>
      <base-btn type="primary" @click="handleClose">
        {{ workflowTexts.button }}
      </base-btn>
    </div>
  </v-card>
</template>
<script>
import i18n from '@/translations/lang'
export default {
  name: 'CheckoutAiTemplate',
  props: {
    type: {
      type: String,
      required: true,
    },
  },
  computed: {
    workflowTexts() {
      if (this.type === 'Subtitle') {
        return {
          title: i18n.t('message.ai.subtitles.generateScreen.title'),
          subtitle: i18n.t('message.ai.subtitles.generateScreen.description'),
          button: i18n.t('message.ai.aiWorkFlowChargeModal.generateButton'),
        }
      } else if (this.type === 'Dubbing') {
        return {
          title: i18n.t('message.ai.dubbings.generateScreen.title'),
          subtitle: i18n.t('message.ai.dubbings.generateScreen.description'),
          button: i18n.t('message.ai.aiWorkFlowChargeModal.generateButton'),
        }
      }
      return {
        title: i18n.t('message.ai.aiWorkFlowChargeModal.generateTitle'),
        subtitle: i18n.t('message.ai.aiWorkFlowChargeModal.generateSubTitle'),
        button: i18n.t('message.ai.aiWorkFlowChargeModal.generateButton'),
      }
    },
  },
  methods: {
    handleClose() {
      this.$root.$emit(`close${this.type}Modal`)
    },
  },
  mounted() {},
}
</script>
<style lang="scss" scoped>
.container-title {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 16px;
}
.w-full {
  width: 100%;
}
</style>
